import { render, staticRenderFns } from "./AllProduct.vue?vue&type=template&id=45d6e5e1&scoped=true"
import script from "./AllProduct.vue?vue&type=script&lang=js"
export * from "./AllProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d6e5e1",
  null
  
)

export default component.exports